import SoftDeleteProjectModal from '@atlassian/jira-project-soft-delete-modal/src/ui/index.tsx';
import { connect } from '@atlassian/jira-react-redux';
import {
	getBaseUrlSelector,
	getProjectIdSelector,
	getProjectTypeSelector,
} from '../../../state/context/selectors';
import { projectNameSelector } from '../../../state/entities/selectors';
import type { AppState } from '../../../state/types';
import {
	trashProjectSuccess,
	closeTrashProjectModal,
	trashProjectFail,
} from '../../../state/ui/actions';
import { dropDownMenuButtonRefSelector } from '../../../state/ui/selectors';

const mapStateToProps = (state: AppState) => ({
	projectName: projectNameSelector(state),
	projectType: getProjectTypeSelector(state),
	baseUrl: getBaseUrlSelector(state),
	projectId: getProjectIdSelector(state),
	isProjectSimplified: true, // This is true as it is Next Gen project details page
	onDeleteSuccessFlagRestore: undefined,
	dropDownMenuButtonRef: dropDownMenuButtonRefSelector(state),
});

const mapDispatchToProps = {
	onDeleteProjectSuccess: trashProjectSuccess,
	onDeleteProjectFailure: trashProjectFail,
	onClose: closeTrashProjectModal,
} as const;

export default connect(mapStateToProps, mapDispatchToProps)(SoftDeleteProjectModal);
